/* eslint-disable no-mixed-spaces-and-tabs */
import {
	FOLDER_NAME,
	default as folderValidationSchema,
} from '@/components/dialogs/AddFolderSharepointDialog/validationSchema';
import { emailSchema } from '@/utils/validation';
import { currentYear, nextYear } from '@/utils/date';
import * as Yup from 'yup';

export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const PHONE = 'phoneNumber';
export const PHONE2 = 'phoneNumber2';
export const DATE_OF_BIRTH = 'dateOfBirth';
export const EMAIL = 'emailAddress';
export const EXISTING_CONTACT = 'existingContact';
export const WEBSITE = 'websiteAddress';
export const FILES = 'files';
export const ADDRESS = 'address';
export const CITY = 'city';
export const SUBURB = 'suburb';
export const STATE = 'state';
export const POSTCODE = 'postcode';
export const COUNTRY = 'country';
export const OTHER_INFO = 'otherInfo';
export const CLIENT_NAME = 'clientName';
export const TRADING_AS = 'tradingAs';
export const ADDRESSEE = 'addressee';
export const SUCCESS_MESSAGE = 'successMessage';
export const ERROR_MESSAGE = 'errorMessage';
export const DEAL_NAME = 'dealName';
export const DEAL_OVERVIEW = 'dealOverview';
export const ADVISER_FEE = 'adviserFee';
export const RENEWAL_DATE = 'renewalDate';
export const ESTIMATED_CLOSE_DATE = 'estimatedCloseDate';
export const DEAL_AMOUNT = 'dealAmount';
export const PROSPECT_AMOUNT = 'prospectAmount';
export const PRIORITY = 'priority';
export const IS_EXISTING = 'isExisting';
export const CLIENT_ID = 'clientId';
export const INDUSTRY = 'industry';
export const ANZSIC_CODE = 'anzsicCode';
export const OWNER_DOC_ID = 'ownerDocId';
export const SALESTEAM = 'salesTeam';
export const COMPLETED_BY = 'completedBy';
export const CLIENT_ERROR = 'clientError';
export const IS_PROSPECT = 'isProspect';
export const SOURCE_OF_BUSINESS = 'sourceOfBusiness';
export const REFERRAL_PARTNER = 'referralPartner';
export const BROKER_GROUP_ID = 'brokerGroupId';

export const ADDITIONAL_SPECIALIST_PRODUCTS = 'additionalSpecialistProducts';
export const LOSS_REASON = 'lossReason';
export const NO_EMPLOYEES = 'numberofemployees';
export const ANNUAL_TURNOVER = 'annualrevenue';

// Client Category
export const CLIENT_CATEGORY = 'clientCategory';
export const WHOLESALE_CLIENT = 'wholesaleClient';
export const VULNERABLE_CLIENT = 'vulnerableClient';

// Goals of cover
export const GOALS_OF_COVER = 'goalsOfCover';
export const ADDITIONAL_GOALS_OF_COVER = 'additionalGoalsOfCover';
export const LOW_ANNUAL_PREMIUM = 'lowAnnualInsurancePremium';
export const HIGH_LEVEL_POLICY_COVERAGE = 'highLevelPolicyCoverage';
export const THOROUGH_TIMELY_ClAIMS_EXPERIENCE = 'thoroughTimelyClaimsExperience';
export const PERSONALISED_SERVICE_REACHABLE_TEAM = 'personalisedServicesReachableTeam';

// Client Type
export const CLIENT_TYPE = 'clientType';
export const COMMERCIAL = 'commercial';
export const DOMESTIC = 'domestic';

//Sharepoint
export const YEAR_FOLDER = 'yearFolder';

//Needs Anaylsis
export const NEEDS_ANALYSIS = 'needsAnalysis';
export const CLIENT_QUOTED = 'clientQuoted';
export const CLIENT_NOT_DISCUSS = 'clientNotDiscussed';
export const CLIENT_NOT_INTERESTED = 'clientNotInterested';
export const CLIENT_NOT_REQUIRED = 'clientNotRequired';
export const CLIENT_NOT_APPLICABLE = 'clientNotApplicable';

//Contact
export const CONTACTS = 'contacts';
export const IS_MAIN_CONTACT = 'isMainContact';
export const ROLE = 'role';
export const CONTACT_ERROR = 'contactError';

// Scope of Advice
export const SCOPE_OF_ADVICE = 'riskClasses';

//Both
export const FULL_NEEDS_ANALYSIS = 'fullNeedsAnalysis';
export const CONTRACT_WORKS = 'contractWorks';
export const RURAL = 'rural';
export const PARAMETRIC = 'parametric';
export const TRAVEL = 'travel';

//If Commercial
export const MATERIAL_DAMAGE = 'materialDamage';
export const BUSINESS_INTERRUPTION = 'businessInterruption';
export const COMMERCIAL_MOTOR = 'commercialMotor';
export const GENERAL_LIABILITY = 'generalLiability';
export const STATUTORY_LIABILITY = 'statutoryLiability'; // Only show if GL is ticked
export const EMPLOYERS_LIABILITY = 'employersLiability'; // Only show if GL is ticked
export const MANAGEMENT_LIABILITY = 'managementLiability'; // If selected, select all GL, SL, EL
export const PROFESSIONAL_INDEMNITY = 'professionalIndemnity';
export const CYBER_LIABILITY = 'cyberLiability';
export const CARRIERS_LIABILITY = 'carriersLiability';
export const CONTRACTORS_PLANT_AND_MACHINERY = 'contractorsPlantAndMachinery';
export const MARINE_CARGO = 'marineCargo';
// export const EQUIPMENT_INSURANCE = 'equipmentInsurance';
// export const MOBILE_PLANT = 'mobilePlant';
// export const ASSOCIATIONS_LIABILITY = 'associationsLiability';
// export const INFORMATION_TECHNOLOGY_LIABILITY = 'informationTechnologyLiability';
// export const SPECIALIST_PLANT = 'specialistPlant';
// export const MARINE_HULL = 'marineHull';
// export const DIRECTORS_OFFICERS_LIABILITY = 'directorsOfficersLiability';
// export const SHIP_REPAIRERS_LIABILITY = 'shipRepairersLiability';

//If Domestic selected

export const HOUSE = 'house';
export const PRIVATE_VEHICLE = 'privateVehicle';
export const CONTENTS = 'contents';
export const BOAT = 'boat';
// export const TRAVEL_CORPORATE = 'travelCorporate';

export const initialValues = {
	[FIRST_NAME]: '',
	[LAST_NAME]: '',
	[PHONE]: '',
	[PHONE2]: '',
	[DATE_OF_BIRTH]: '',
	[EMAIL]: '',
	[WEBSITE]: '',
	[CONTACTS]: [
		{
			firstName: '',
			lastName: '',
			emailAddress: '',
			phoneNumber: '',
			phoneNumber2: '',
			dateOfBirth: '',
			isMainContact: false,
			role: '',
			existingContact: false,
		},
	],
	[FILES]: [],
	[ADDRESS]: '',
	[CITY]: '',
	[STATE]: '',
	[COUNTRY]: '',
	[OTHER_INFO]: '',
	[CLIENT_NAME]: '',
	[TRADING_AS]: '',
	[CLIENT_ERROR]: false,
	[CONTACT_ERROR]: false,
	[SUCCESS_MESSAGE]: '',
	[ERROR_MESSAGE]: '',
	[DEAL_NAME]: '',
	[DEAL_OVERVIEW]: '',
	[FOLDER_NAME]: '',
	[ADVISER_FEE]: '',
	[RENEWAL_DATE]: null,
	[ESTIMATED_CLOSE_DATE]: null,
	[DEAL_AMOUNT]: 0,
	[PROSPECT_AMOUNT]: 0,
	[IS_EXISTING]: false,
	[CLIENT_ID]: null,
	[INDUSTRY]: null,
	[ANZSIC_CODE]: null,
	[OWNER_DOC_ID]: null,
	[SALESTEAM]: null,
	[COMPLETED_BY]: null,
	[POSTCODE]: '',
	[SUBURB]: '',
	[GOALS_OF_COVER]: [],
	[ADDITIONAL_GOALS_OF_COVER]: '',
	[CLIENT_CATEGORY]: [],
	[SCOPE_OF_ADVICE]: [],
	[NEEDS_ANALYSIS]: [],
	[CLIENT_TYPE]: '',
	[ADDITIONAL_SPECIALIST_PRODUCTS]: '',
	[NO_EMPLOYEES]: 0,
	[ANNUAL_TURNOVER]: 0,
	[IS_PROSPECT]: false,
	[YEAR_FOLDER]: `${currentYear}-${nextYear}`,
	[SOURCE_OF_BUSINESS]: null,
	[REFERRAL_PARTNER]: '',
	[BROKER_GROUP_ID]: '',
};

export const CLIENT_CATEGORY_LABELS = {
	[WHOLESALE_CLIENT]: 'Wholesale Client',
	[VULNERABLE_CLIENT]: 'Vulnerable Client',
};

export const NEEDS_ANALYSIS_LABELS = {
	[CLIENT_QUOTED]: 'Would like to be quoted',
	[CLIENT_NOT_DISCUSS]: 'Client did not want to discuss',
	[CLIENT_NOT_INTERESTED]: 'Discussed but not interested at this time',
	[CLIENT_NOT_REQUIRED]: 'Discussed but not required at this time',
	[CLIENT_NOT_APPLICABLE]: 'Discussed but not applicable at this time',
};

export const GOALS_OF_COVER_LABELS = {
	[LOW_ANNUAL_PREMIUM]: 'Low annual insurance premium',
	[HIGH_LEVEL_POLICY_COVERAGE]: 'High level of policy coverage',
	[THOROUGH_TIMELY_ClAIMS_EXPERIENCE]: 'Thorough and timely claims experience',
	[PERSONALISED_SERVICE_REACHABLE_TEAM]: 'Personalised service/reachable team',
};

const isRequired = (isExisting, isProspect, prospect2Feature) => {
	if (isExisting) {
		return false;
	}
	if (isProspect && prospect2Feature) {
		return false;
	}
	return true;
};

const newBusinessValidationSchema = (
	isFolioOrCbnLedger,
	isAustralian,
	contactNonRequired,
	isClassOfRiskRequired = false,
	isDealAmountRequired = false,
) => {
	return Yup.object()
		.shape({
			[IS_EXISTING]: Yup.boolean(),
			[IS_PROSPECT]: Yup.boolean(),
			[FIRST_NAME]: Yup.string().when(['isExisting', 'contacts'], {
				is: (isExisting, contacts) => !isExisting && (!contacts || contacts.length === 0),
				then: () => Yup.string().required('First name is required.'),
				otherwise: () => Yup.string(),
			}),
			[LAST_NAME]: Yup.string().when(['isExisting', 'contacts'], {
				is: (isExisting, contacts) => !isExisting && (!contacts || contacts.length === 0),
				then: () => Yup.string().required('Last name is required.'),
				otherwise: () => Yup.string(),
			}),
			[YEAR_FOLDER]: Yup.string().when(['isProspect', 'prospect2Feature'], {
				is: (isProspect, prospect2Feature) => !isProspect || !prospect2Feature,
				then: () => Yup.string().required('Year folder is required.'),
				otherwise: () => Yup.string().notRequired(),
			}),
			[PHONE]: Yup.string().when(['isExisting', 'contacts'], {
				is: (isExisting, contacts) => !isExisting && (!contacts || contacts.length === 0),
				then: () =>
					Yup.string()
						.required('Phone number is required.')
						.min(7, 'Phone number should be more than 7 characters')
						.max(15, 'Phone number should be no more than 15 characters'),
				otherwise: () => Yup.string(),
			}),
			[DATE_OF_BIRTH]: Yup.date()
				.nullable(true)
				.max(new Date(), 'Date of birth cannot be in the future'),
			[EMAIL]: Yup.string().when(['isExisting', 'contacts'], {
				is: (isExisting, contacts) => !isExisting && (!contacts || contacts.length === 0),
				then: () => emailSchema(),
				otherwise: () => emailSchema(false),
			}),
			[ADDRESS]: Yup.string().when(['isExisting', 'isProspect', 'prospect2Feature'], {
				is: (isExisting, isProspect, prospect2Feature) =>
					(isAustralian && !isExisting) ||
					(!contactNonRequired && isRequired(isExisting, isProspect, prospect2Feature)),
				then: () =>
					Yup.string()
						.required('Address is required')
						.max(40, 'Address cannot be longer than 40 characters'),
				otherwise: () => Yup.string().notRequired(),
			}),
			[CITY]: Yup.string().when(['isExisting', 'isProspect', 'prospect2Feature'], {
				is: (isExisting, isProspect, prospect2Feature) =>
					!isAustralian &&
					!contactNonRequired &&
					isRequired(isExisting, isProspect, prospect2Feature),
				then: () => Yup.string().required('City is required'),
				otherwise: () => Yup.string().notRequired(),
			}),
			[SUBURB]: Yup.string().when(['isExisting', 'isProspect', 'prospect2Feature'], {
				is: (isExisting, isProspect, prospect2Feature) =>
					(isAustralian && !isExisting) ||
					(!contactNonRequired && isRequired(isExisting, isProspect, prospect2Feature)),
				then: () => Yup.string().required('Suburb is required'),
				otherwise: () => Yup.string().notRequired(),
			}),
			[POSTCODE]: Yup.string().when(['isExisting', 'isProspect', 'prospect2Feature'], {
				is: (isExisting, isProspect, prospect2Feature) =>
					(isAustralian && !isExisting) ||
					(!contactNonRequired && isRequired(isExisting, isProspect, prospect2Feature)),
				then: () => Yup.string().required('Postcode is required'),
				otherwise: () => Yup.string().notRequired(),
			}),
			[COUNTRY]: Yup.string().when(['isExisting', 'isProspect', 'prospect2Feature'], {
				is: (isExisting, isProspect, prospect2Feature) =>
					(isAustralian && !isExisting) ||
					(!contactNonRequired && isRequired(isExisting, isProspect, prospect2Feature)),
				then: () => Yup.string().required('Country is required'),
				otherwise: () => Yup.string().notRequired(),
			}),
			[CLIENT_NAME]: Yup.string().when('isExisting', {
				is: (isExisting) => !isExisting,
				then: () => Yup.string().required('Client name is required.'),
				otherwise: () => Yup.string(),
			}),
			[ANZSIC_CODE]: Yup.object().when(['isExisting'], {
				is: (isExisting) => isAustralian && !isExisting,
				then: () => Yup.object().required('ANZSIC code is required.'),
				otherwise: () => Yup.object().notRequired(),
			}),
			[CLIENT_ERROR]: Yup.boolean().test(
				'client-error',
				'Client error',
				(value) => value === false,
			),
			[CLIENT_ID]: Yup.string().when('isExisting', {
				is: (isExisting) => isExisting,
				then: () => Yup.string().required('Client is required.'),
				otherwise: () => Yup.string().nullable(true),
			}),
			// [DEAL_NAME]: Yup.string().required('Deal name is required.'),
			// [FOLDER_NAME]: Yup.string()
			// 	.required('Folder name is required.')
			// 	.max(FOLDER_NAME_MAX, `Folder name can be maximum of ${FOLDER_NAME_MAX} characters`),
			[WEBSITE]: Yup.string(),
			[FILES]: Yup.array(),
			[OTHER_INFO]: Yup.string(),
			[RENEWAL_DATE]: Yup.date().nullable(true),
			[ADVISER_FEE]: Yup.number().nullable(true),
			[SCOPE_OF_ADVICE]: Yup.array().when([IS_PROSPECT], {
				is: (isProspect) => !isProspect && isClassOfRiskRequired,
				then: () =>
					Yup.array()
						.min(1, 'Risk Classes are required.')
						.required('Risk Classes are required.'),
				otherwise: () => Yup.array().notRequired(),
			}),
			[DEAL_AMOUNT]: Yup.number().when([IS_PROSPECT], {
				is: (isProspect) => !isProspect && isDealAmountRequired,
				then: () =>
					Yup.number()
						.required('Deal amount is required')
						.moreThan(0, 'Deal amount must be greater than zero')
						.nullable(false),
				otherwise: () => Yup.number().nullable(true),
			}),

			[CONTACT_ERROR]: Yup.boolean().test(
				'contact-error',
				'Contact error must be false',
				(value) => value === false,
			),
			[CONTACTS]: Yup.array().when(['isExisting'], {
				is: (isExisting) => !isExisting,
				then: () =>
					Yup.array()
						.of(
							Yup.object().shape({
								firstName: Yup.string().required('First name is required.'),
								lastName: Yup.string().required('Last name is required.'),
								emailAddress: isFolioOrCbnLedger
									? emailSchema()
									: emailSchema(false),

								phoneNumber: isFolioOrCbnLedger
									? Yup.string()
											.required('Phone number is required.')
											.min(7, 'Phone number should be more than 7 characters')
											.max(
												15,
												'Phone number should be no more than 15 characters',
											)
									: Yup.string()
											.notRequired()
											.max(
												15,
												'Phone number should be no more than 15 characters',
											),
								phoneNumber2: Yup.string()
									.notRequired()
									.min(7, 'Phone number should be more than 7 characters')
									.max(
										15,
										'Alternative number should be no more than 15 characters',
									)
									.optional(),
								dateOfBirth: Yup.date()
									.nullable(true)
									.max(new Date(), 'Date of birth cannot be in the future'),
							}),
						)
						.min(1, 'At least one contact is required')
						.test(
							'unique-emails',
							'Email addresses must be unique',
							function (contacts) {
								if (!contacts || contacts.length === 0) return true;

								const emailSet = new Set();
								for (let i = 0; i < contacts.length; i++) {
									const email = contacts[i].emailAddress;
									if (email && emailSet.has(email)) {
										return this.createError({
											path: `${this.path}[${i}].emailAddress`,
											message: 'Email addresses must be unique',
										});
									}
									if (email) {
										emailSet.add(email);
									}
								}
								return true;
							},
						),
				otherwise: () => Yup.array().notRequired(),
			}),
		})
		.concat(folderValidationSchema([], 'Deal name'));
};

export default newBusinessValidationSchema;
